import { state } from '@angular/animations';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ConfigurationService {
  private Environment: 'Local' | 'Production' | 'Stage' = 'Local'; //Production,Stage,Local

  private EnvironmentObject = {
    Local: {
      apiUrl: 'http://localhost:3000/'
      // apiUrl:'http://192.168.123.248:3001/'
    },

    Stage: {
      apiUrl: location.origin + '/',
    },
    Production: {
      // apiUrl:"http://localhost:3001"
      apiUrl: location.origin + '/',
    },
  };
  constructor() {
    if (location.origin.includes('localhost')) {
      this.Environment = 'Local';
    } else {
      this.Environment = 'Production';
    }
  }

  getBaseUrl() {
    return this.EnvironmentObject[this.Environment]['apiUrl'];
    // return this.EnvironmentObject[this.Environment]['apiUrl']+'/'
  }
}
